import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Contact() {
    const [form, setForm] = useState({ name: "", email: "", message: "" });
    const [sending, setSending] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setSending(true);
        try {
            await api.post("/contact", form);
            toast.success("Message sent. We'll be in touch.");
            setForm({ name: "", email: "", message: "" });
        } catch (err) {
            toast.error("Something went wrong. Please try again.");
        } finally {
            setSending(false);
        }
    };

    return (
        <div data-testid="contact-page" className="pt-32 pb-24 mx-auto max-w-[900px] px-6 lg:px-10">
            <span className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#FFD400]">Contact</span>
            <h1 className="mt-2 font-display text-5xl sm:text-6xl font-black tracking-tight">Let's talk.</h1>
            <p className="mt-4 text-white/60">Collab, licensing, press, or fan mail — drop a line.</p>

            <form onSubmit={submit} className="mt-10 grid grid-cols-1 gap-5">
                <div>
                    <label className="text-xs uppercase tracking-widest text-white/50">Name</label>
                    <input
                        data-testid="contact-name"
                        required
                        value={form.name}
                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                        className="mt-2 w-full bg-white/5 border border-white/10 rounded-[14px] px-4 py-3 text-white focus:border-[#FFD400] outline-none transition-colors"
                    />
                </div>
                <div>
                    <label className="text-xs uppercase tracking-widest text-white/50">Email</label>
                    <input
                        data-testid="contact-email"
                        type="email"
                        required
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        className="mt-2 w-full bg-white/5 border border-white/10 rounded-[14px] px-4 py-3 text-white focus:border-[#FFD400] outline-none transition-colors"
                    />
                </div>
                <div>
                    <label className="text-xs uppercase tracking-widest text-white/50">Message</label>
                    <textarea
                        data-testid="contact-message"
                        required
                        rows={6}
                        value={form.message}
                        onChange={(e) => setForm({ ...form, message: e.target.value })}
                        className="mt-2 w-full bg-white/5 border border-white/10 rounded-[14px] px-4 py-3 text-white focus:border-[#FFD400] outline-none transition-colors resize-none"
                    />
                </div>
                <button
                    data-testid="contact-submit"
                    disabled={sending}
                    className="mt-2 self-start bg-[#FFD400] text-black font-bold rounded-full px-7 py-3.5 hover:scale-105 transition-transform disabled:opacity-60 disabled:hover:scale-100"
                >
                    {sending ? "Sending…" : "Send Message"}
                </button>
            </form>
        </div>
    );
}
